import React, { useState } from 'react';
import LoadingPage from './pages/LoadingPage';
import EnterOTP from './pages/EnterOTP';
import { getUrlParams, redirectToApp } from './utils/common';
import Socket from './components/Socket';
import Modal from './components/ModalOTP';
import { useMst } from './models/Root';
import { observer } from 'mobx-react-lite';
import './App.css';

const EVENT_ENTER_OTP = 'GO_TO_ENTER_OTP';
const EVENT_CHECK_OTP = "CHECK_OTP_FROM_FINHUB"

function App() {
    const [isLoading, setOTPLoading] = useState(true);
    const [enterOTP, setEnterOTP] = useState(false);
    const [isShowDialog, setShowDialog] = useState(false);
    const [modalData, setModalData] = useState({ title: "OTP hợp lệ", content: `Bạn vui lòng chọn "Đóng" và giao dịch sẽ được cập nhật trong giây lát!` })
    const [expiredAt, setExpiredAt] = useState(Date.now() + 10000)
    const request_id = getUrlParams('request_id');
    const { otp, analytics } = useMst();
    const { setLoading, changeDisableResendOTP, setOpenDialog, state, setState } = otp;
    const handlerOpenEnterOTP = (data) => {
        let { status, expiredAt } = JSON.parse(data)
        if (status) {
            changeDisableResendOTP(true)
            setEnterOTP(true)
            setExpiredAt(expiredAt)
            setOTPLoading(false)
            setLoading(false)
            analytics.logEvent("otp_screen")
            setTimeout(() => {
                changeDisableResendOTP(false)
            }, 30000)
        }
    }

    const closeDialog = () => {
        setShowDialog(false)
        console.log('close app.js')
        analytics.logEvent("otp_dialog_close")
        redirectToApp()
    }

    const openDialog = () => {
        setShowDialog(true)
    }

    const handlerResponseEnterOTP = (data) => {
        let resData = JSON.parse(data)
        openDialog();
        if (state === 'pending') {
            setState('success')
            if (!resData.status) {
                switch (resData.error) {
                    case 'expired_otp':
                        setModalData({
                            title: "OTP hết hạn",
                            content: `Bạn vui lòng chọn "Đóng" và thử lại sau nhé!`
                        })
                        analytics.logEvent("expired_otp")
                        setLoading(false)
                        break;
                    case 'wrong_otp':
                        setModalData({
                            title: "Sai mã OTP",
                            content: `Bạn vui lòng chọn "Đóng" và thử lại sau nhé!`
                        })
                        analytics.logEvent("wrong_otp")
                        setLoading(false)
                        break;
                    case 'merchant.failed':
                        setModalData({
                            title: "Lỗi kết nối",
                            content: `Bạn vui lòng chọn "Đóng" và thử lại sau nhé. Rất xin lỗi bạn vì sự bất tiện này!`
                        })
                        analytics.logEvent("otp_merchant_failed")
                        setLoading(false)
                        break;
                    default:
                        setModalData({
                            title: "Lỗi kết nối",
                            content: `Bạn vui lòng chọn "Đóng" và thử lại sau nhé. Rất xin lỗi bạn vì sự bất tiện này!`
                        })
                        setLoading(false)
                        break;
                }
            } else {
                if (resData.otp === false) {
                    analytics.logEvent("no_otp_in_bank_otp")
                    redirectToApp()
                } else {
                    setModalData({
                        title: "OTP hợp lệ",
                        content: `Bạn vui lòng chọn "Đóng" và giao dịch  sẽ được cập nhật trong giây lát!`
                    })
                    analytics.logEvent("valid_otp")
                }
            }
        }

        setOpenDialog();
        setLoading(false)
    }

    return (
        <div className="app">
            {isLoading ?
                <LoadingPage /> : <EnterOTP
                    expiredAt={expiredAt}
                    request_id={request_id}
                />}
            <Socket
                rooms={request_id}
                events={EVENT_ENTER_OTP}
                onEmit={handlerOpenEnterOTP}
            />
            {enterOTP ? <Socket
                rooms={request_id}
                events={EVENT_CHECK_OTP}
                onEmit={handlerResponseEnterOTP}
            /> : <Socket
                rooms={request_id}
                events={EVENT_CHECK_OTP}
                onEmit={handlerResponseEnterOTP}
            />}
            <Modal title={modalData.title} content={modalData.content} isShowDialog={isShowDialog} close={closeDialog} />
        </div>
    );
}

export default observer(App);
